import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Companies
export const getCompanies = (page, perPage) => axios.get(`${API}/companies`, { params: { page: page || 1, per_page: perPage || 25 } });
export const getMyCompanies = () => axios.get(`${API}/companies/my-companies`);
export const getCompany = (id) => axios.get(`${API}/companies/${id}`);
export const createCompany = (data) => axios.post(`${API}/companies`, data);
export const updateCompany = (id, data) => axios.put(`${API}/companies/${id}`, data);
export const toggleSubscriptionOverride = (id, data) => axios.put(`${API}/companies/${id}/subscription-override`, data);
export const deleteCompany = (id) => axios.delete(`${API}/companies/${id}`);

// Locations
export const getLocations = (companyId, companyIds, includeDeleted, page, perPage, search) => axios.get(`${API}/locations`, { params: { company_id: companyId, company_ids: companyIds, include_deleted: includeDeleted || undefined, page: page || 1, per_page: perPage || 25, search: search || undefined } });
export const getLocation = (id) => axios.get(`${API}/locations/${id}`);
export const createLocation = (data) => axios.post(`${API}/locations`, data);
export const updateLocation = (id, data) => axios.put(`${API}/locations/${id}`, data);
export const deleteLocation = (id) => axios.delete(`${API}/locations/${id}`);
export const getLocationFinancials = (id, startDate, endDate) => 
  axios.get(`${API}/locations/${id}/financials`, { params: { start_date: startDate, end_date: endDate } });

// Machines
export const getMachines = (companyId, locationId, companyIds, page, perPage) => 
  axios.get(`${API}/machines`, { params: { company_id: companyId, location_id: locationId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });
export const getMachine = (id) => axios.get(`${API}/machines/${id}`);
export const createMachine = (data) => axios.post(`${API}/machines`, data);
export const updateMachine = (id, data) => axios.put(`${API}/machines/${id}`, data);
export const deleteMachine = (id) => axios.delete(`${API}/machines/${id}`);
export const getNextMachineNumber = () => axios.get(`${API}/machines/next-number`);

// Collections
export const getCollections = (params) => axios.get(`${API}/collections`, { params });
export const createCollection = (data) => axios.post(`${API}/collections`, data);
export const updateCollection = (id, data) => axios.put(`${API}/collections/${id}`, data);
export const editGroupCollections = (data) => axios.put(`${API}/collections/group-edit`, data);
export const recalculateSplits = (data) => axios.post(`${API}/collections/recalculate-splits`, data);
export const getCollectionRevisions = (collectionId) => axios.get(`${API}/collections/${collectionId}/revisions`);
export const getGroupRevisions = (collectionIds) => axios.get(`${API}/collections/group-revisions`, { params: { collection_ids: collectionIds.join(',') } });
export const deleteCollection = (id) => axios.delete(`${API}/collections/${id}`);
export const checkDuplicateCollection = (locationId, startDate, endDate) => 
  axios.get(`${API}/collections/check-duplicate`, { 
    params: { location_id: locationId, start_date: startDate, end_date: endDate } 
  });
export const sendCollectionReport = (data) => axios.post(`${API}/collections/send-report`, data);
export const getCollectors = (companyId) => axios.get(`${API}/collections/collectors`, { params: { company_id: companyId } });
export const getPendingCollectionsSummary = (companyId, companyIds) => axios.get(`${API}/collections/pending-summary`, { params: { company_id: companyId, company_ids: companyIds } });
export const resolvePendingCollection = (id, data) => axios.put(`${API}/collections/${id}/resolve-pending`, data);
export const getRolledOverCollections = (locationId) => axios.get(`${API}/collections/rolled-over/${locationId}`);

// Partners
export const getPartners = (companyId, page, perPage) => axios.get(`${API}/partners`, { params: { company_id: companyId, page: page || 1, per_page: perPage || 25 } });
export const createPartner = (data) => axios.post(`${API}/partners`, data);
export const updatePartner = (id, data) => axios.put(`${API}/partners/${id}`, data);
export const deletePartner = (id) => axios.delete(`${API}/partners/${id}`);
export const addCompanyToPartner = (partnerId, ownershipData) => axios.post(`${API}/partners/${partnerId}/add-company`, ownershipData);
export const removeCompanyFromPartner = (partnerId, companyId) => axios.delete(`${API}/partners/${partnerId}/remove-company/${companyId}`);

// Routes
export const getRoutes = (companyId, companyIds) => axios.get(`${API}/routes`, { params: { company_id: companyId, company_ids: companyIds } });
export const createRoute = (data) => axios.post(`${API}/routes`, data);
export const updateRoute = (id, data) => axios.put(`${API}/routes/${id}`, data);
export const deleteRoute = (id) => axios.delete(`${API}/routes/${id}`);

// Users
export const getUsers = (companyId, companyIds, page, perPage) => axios.get(`${API}/users`, { params: { company_id: companyId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });
export const createUser = (data) => axios.post(`${API}/users`, data);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);

// Dashboard
export const getDashboardStats = (companyId, companyIds, days) => axios.get(`${API}/dashboard/stats`, { params: { company_id: companyId, company_ids: companyIds, days } });
export const getDashboardChartData = (companyId, days = 30, companyIds) => axios.get(`${API}/dashboard/chart-data`, { params: { company_id: companyId, days, company_ids: companyIds } });

// Reports
export const getMachineAccountingReport = (groupBy, startDate, endDate, managerId, locationId, companyId) => 
  axios.get(`${API}/reports/machine-accounting`, { 
    params: { group_by: groupBy, start_date: startDate, end_date: endDate, manager_id: managerId, location_id: locationId, company_id: companyId } 
  });

// Location Managers
export const getLocationManagers = () => axios.get(`${API}/users`, { params: { page: 1, per_page: 500 } }).then(res => ({
  ...res,
  data: (res.data?.data || res.data || []).filter(u => u.role === 'location_manager')
}));

// User Permissions
export const getUserPermissions = () => axios.get(`${API}/auth/permissions`);

export const exportReport = (reportType, params) => 
  axios.get(`${API}/reports/export`, { 
    params: { report_type: reportType, ...params },
    responseType: 'blob'
  });

// Seed
export const seedSuperAdmin = () => axios.post(`${API}/seed/super-admin`);

// Vendors (for inventory)
export const getVendors = (companyId, companyIds, page, perPage) => axios.get(`${API}/vendors`, { params: { company_id: companyId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });

// Games
export const getGames = (companyId, companyIds, page, perPage) => axios.get(`${API}/games`, { params: { company_id: companyId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });
export const createGame = (data) => axios.post(`${API}/games`, data);
export const deleteGame = (id) => axios.delete(`${API}/games/${id}`);
export const checkGameAssignment = (gameId) => axios.get(`${API}/games/${gameId}/assignment`);
export const transferGameToMachine = (gameId, targetMachineId) => 
  axios.post(`${API}/games/${gameId}/transfer?target_machine_id=${targetMachineId}`);

// Inventory
export const getInventoryItems = (category, companyId, companyIds) => axios.get(`${API}/inventory`, { params: { category, company_id: companyId, company_ids: companyIds } });
export const createInventoryItem = (data) => axios.post(`${API}/inventory`, data);
export const updateInventoryItem = (id, data) => axios.put(`${API}/inventory/${id}`, data);
export const deleteInventoryItem = (id) => axios.delete(`${API}/inventory/${id}`);
export const adjustInventory = (id, data) => axios.post(`${API}/inventory/${id}/adjust`, data);
export const getInventoryTransactions = (itemId) => axios.get(`${API}/inventory/transactions`, { params: { item_id: itemId } });
export const getLowStockItems = (companyId) => axios.get(`${API}/inventory/low-stock`, { params: { company_id: companyId } });

// Invoices
export const getInvoices = (status, companyId, companyIds, page, perPage) => axios.get(`${API}/invoices`, { params: { status, company_id: companyId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });
export const getInvoice = (id) => axios.get(`${API}/invoices/${id}`);
export const createInvoice = (data) => axios.post(`${API}/invoices`, data);
export const updateInvoice = (id, data) => axios.put(`${API}/invoices/${id}`, data);
export const updateInvoiceStatus = (id, status) => axios.put(`${API}/invoices/${id}/status`, null, { params: { status } });
export const recordPayment = (id, amount, paymentType, referenceNumber) => axios.post(`${API}/invoices/${id}/payment`, null, { params: { amount, payment_type: paymentType, reference_number: referenceNumber } });
export const getInvoicePayments = (id) => axios.get(`${API}/invoices/${id}/payments`);
export const deleteInvoice = (id) => axios.delete(`${API}/invoices/${id}`);
export const getInvoicePdf = (id) => axios.get(`${API}/invoices/${id}/pdf`, { responseType: 'blob' });
export const sendInvoiceEmail = (id) => axios.post(`${API}/invoices/${id}/send`);

// Payouts
export const getPayouts = (startDate, endDate, companyId) => 
  axios.get(`${API}/payouts`, { params: { start_date: startDate, end_date: endDate, company_id: companyId } });
export const getPayoutsSummary = (startDate, endDate) => 
  axios.get(`${API}/payouts/summary`, { params: { start_date: startDate, end_date: endDate } });
export const getCompanyPayouts = (companyId, startDate, endDate) => 
  axios.get(`${API}/payouts/company/${companyId}`, { params: { start_date: startDate, end_date: endDate } });
export const exportPayouts = (startDate, endDate, companyId) => 
  axios.get(`${API}/payouts/export`, { 
    params: { start_date: startDate, end_date: endDate, company_id: companyId },
    responseType: 'blob'
  });

// Location Portal APIs
// Admin functions
export const generateLocationCredentials = (locationId, username) => 
  axios.post(`${API}/location-portal/generate-credentials`, null, { params: { location_id: locationId, username } });
export const resetLocationPassword = (locationId) => axios.post(`${API}/location-portal/reset-password/${locationId}`);
export const revokeLocationAccess = (locationId) => axios.delete(`${API}/location-portal/revoke-access/${locationId}`);
export const getLocationCredentials = (companyId) => 
  axios.get(`${API}/location-portal/credentials`, { params: { company_id: companyId } });

// Location user functions
export const getMyLocations = () => axios.get(`${API}/location-portal/my-locations`);
export const getMyLocation = (locationId) => axios.get(`${API}/location-portal/my-location`, { params: { location_id: locationId } });
export const getMyMachines = (locationId) => axios.get(`${API}/location-portal/my-machines`, { params: { location_id: locationId } });

// Bookkeeping
export const createBookkeepingEntry = (data) => axios.post(`${API}/location-portal/bookkeeping`, data);
export const getBookkeepingEntries = (params) => axios.get(`${API}/location-portal/bookkeeping`, { params });
export const updateBookkeepingEntry = (entryId, data) => axios.put(`${API}/location-portal/bookkeeping/${entryId}`, data);
export const deleteBookkeepingEntry = (entryId) => axios.delete(`${API}/location-portal/bookkeeping/${entryId}`);

// Credits
export const createCredit = (data) => axios.post(`${API}/location-portal/credits`, data);
export const getCredits = (params) => axios.get(`${API}/location-portal/credits`, { params });

// Service Calls
export const createServiceCall = (data) => axios.post(`${API}/location-portal/service-calls`, data);
export const getMyServiceCalls = (status, locationId) => axios.get(`${API}/location-portal/service-calls`, { params: { status, location_id: locationId } });
export const getServiceCall = (callId) => axios.get(`${API}/location-portal/service-calls/${callId}`);

// Admin service calls
export const getAllServiceCalls = (params) => axios.get(`${API}/location-portal/admin/service-calls`, { params });
export const updateServiceCallStatus = (callId, status, notes) => 
  axios.put(`${API}/location-portal/admin/service-calls/${callId}/status`, null, { params: { status, notes } });

// Reports
export const getLocationReportSummary = (startDate, endDate, locationId) => 
  axios.get(`${API}/location-portal/reports/summary`, { params: { start_date: startDate, end_date: endDate, location_id: locationId } });
export const getDailySummaryReport = (startDate, endDate, locationId) =>
  axios.get(`${API}/location-portal/reports/daily-summary`, { params: { start_date: startDate, end_date: endDate, location_id: locationId } });

// Employee Management
export const createEmployee = (data) => axios.post(`${API}/location-portal/employees`, data);
export const getEmployees = (locationId) => axios.get(`${API}/location-portal/employees`, { params: { location_id: locationId } });
export const updateEmployee = (employeeId, data) => axios.put(`${API}/location-portal/employees/${employeeId}`, data);
export const resetEmployeePassword = (employeeId) => axios.post(`${API}/location-portal/employees/${employeeId}/reset-password`);
export const deleteEmployee = (employeeId) => axios.delete(`${API}/location-portal/employees/${employeeId}`);

// Bulk Bookkeeping
export const createBulkBookkeepingEntries = (data) => axios.post(`${API}/location-portal/bookkeeping/bulk`, data);

// Update shift for a date's entries
export const updateShiftEntries = (date, oldShift, newShift, locationId) => 
  axios.put(`${API}/location-portal/bookkeeping/update-shift`, { date, old_shift: oldShift, new_shift: newShift, location_id: locationId });

// Get detailed entries for a specific date and shift
export const getShiftEntryDetails = (date, shift, batchId, locationId) => 
  axios.get(`${API}/location-portal/bookkeeping/shift-details`, { params: { date, shift, batch_id: batchId, location_id: locationId } });

// Upload verification image for bookkeeping
export const uploadVerificationImage = (file, entryDate, shift) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('entry_date', entryDate);
  formData.append('shift', shift);
  return axios.post(`${API}/location-portal/bookkeeping/upload-verification`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Get bookkeeping images
export const getBookkeepingImages = (entryDate, shift, locationId) => 
  axios.get(`${API}/location-portal/bookkeeping/images`, { params: { entry_date: entryDate, shift, location_id: locationId } });

// Get portal lifetime for a machine
export const getPortalMachineLifetime = (machineId, locationId) =>
  axios.get(`${API}/location-portal/bookkeeping/lifetime/${machineId}`, { params: { location_id: locationId } });

// Money Bank
export const getMoneyBank = (locationId) =>
  axios.get(`${API}/location-portal/money-bank`, { params: { location_id: locationId } });
export const initializeMoneyBank = (data) =>
  axios.post(`${API}/location-portal/money-bank/initialize`, data);
export const getMoneyBankHistory = (params) =>
  axios.get(`${API}/location-portal/money-bank/history`, { params });

// Money Distributions
export const createMoneyDistribution = (data) =>
  axios.post(`${API}/location-portal/money-distribution`, data);
export const getMoneyDistributions = (params) =>
  axios.get(`${API}/location-portal/money-distributions`, { params });
export const updateMoneyDistribution = (distId, data) =>
  axios.put(`${API}/location-portal/money-distribution/${distId}`, data);

// Batch Edit
export const updateBatchEntries = (batchId, data) =>
  axios.put(`${API}/location-portal/bookkeeping/batch/${batchId}`, data);
export const getEditHistory = (params) =>
  axios.get(`${API}/location-portal/edit-history`, { params });

// Settlements
export const createSettlement = (data) =>
  axios.post(`${API}/location-portal/settlement`, data);
export const getSettlements = (locationId) =>
  axios.get(`${API}/location-portal/settlements`, { params: { location_id: locationId } });
export const getSettlementDetail = (settlementId) =>
  axios.get(`${API}/location-portal/settlement/${settlementId}`);

// Notifications
export const getNotifications = () => axios.get(`${API}/notifications`);
export const getUnreadNotificationCount = () => axios.get(`${API}/notifications/unread-count`);
export const markNotificationRead = (id) => axios.put(`${API}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API}/notifications/read-all`);
export const deleteNotification = (id) => axios.delete(`${API}/notifications/${id}`);

// Issues
export const getIssues = (companyId, companyIds, page, perPage) => axios.get(`${API}/issues`, { params: { company_id: companyId, company_ids: companyIds, page: page || 1, per_page: perPage || 25 } });
export const createIssue = (data) => axios.post(`${API}/issues`, data);
export const updateIssue = (id, data) => axios.put(`${API}/issues/${id}`, data);
export const deleteIssue = (id) => axios.delete(`${API}/issues/${id}`);

// Role Permissions
export const getRolePermissions = (companyId) => axios.get(`${API}/role-permissions`, { params: { company_id: companyId } });
export const getDefaultPermissions = () => axios.get(`${API}/role-permissions/defaults`);
export const getCompanyPermissions = (companyId) => axios.get(`${API}/role-permissions/company/${companyId}`);
export const getCompanyRolePermission = (companyId, role) => axios.get(`${API}/role-permissions/company/${companyId}/role/${role}`);
export const createOrUpdateRolePermission = (data) => axios.post(`${API}/role-permissions`, data);
export const resetRolePermission = (companyId, role) => axios.post(`${API}/role-permissions/reset/${companyId}/${role}`);
export const getMyPermissions = () => axios.get(`${API}/role-permissions/my-permissions`);

// Subscriptions
export const getSubscriptionPlans = () => axios.get(`${API}/subscriptions/plans`);
export const getMySubscription = () => axios.get(`${API}/subscriptions/my-subscription`);
export const getCompanySubscription = (companyId) => axios.get(`${API}/subscriptions/company/${companyId}`);
export const startTrial = (companyId, tier = 'pro') => axios.post(`${API}/subscriptions/start-trial`, null, { params: { company_id: companyId, tier } });
export const createCheckoutSession = (data) => axios.post(`${API}/subscriptions/checkout`, data);
export const getCheckoutStatus = (sessionId) => axios.get(`${API}/subscriptions/checkout/status/${sessionId}`);
export const addLocationsCheckout = (data) => axios.post(`${API}/subscriptions/add-locations`, data);
export const getPaymentTransactions = (companyId) => axios.get(`${API}/subscriptions/transactions`, { params: { company_id: companyId } });
export const cancelSubscription = (companyId) => axios.post(`${API}/subscriptions/cancel`, null, { params: { company_id: companyId } });
export const checkFeatureAccess = (feature) => axios.get(`${API}/subscriptions/check-feature/${feature}`);
export const getLocationUsage = () => axios.get(`${API}/subscriptions/location-usage`);


// Import from Excel
export const downloadLocationsTemplate = () => axios.get(`${API}/import/sample/locations`, { responseType: 'blob' });
export const downloadMachinesTemplate = () => axios.get(`${API}/import/sample/machines`, { responseType: 'blob' });
export const downloadGamesTemplate = () => axios.get(`${API}/import/sample/games`, { responseType: 'blob' });
export const importLocations = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/import/locations`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const importMachines = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/import/machines`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const importGames = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/import/games`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Collections with carry forward
export const getCarryForward = (locationId) => axios.get(`${API}/collections/carry-forward/${locationId}`);
export const getLocationsWithMachines = () => axios.get(`${API}/collections/locations-with-machines`);
export const getLifetimeData = (machineId) => axios.get(`${API}/collections/lifetime/${machineId}`);



// Guide
export const getGuideSteps = () => axios.get(`${API}/guide/steps`);
export const markGuideStepComplete = (stepId) => axios.put(`${API}/guide/steps/${stepId}/complete`);
export const unmarkGuideStep = (stepId) => axios.put(`${API}/guide/steps/${stepId}/uncomplete`);
export const resetGuideProgress = () => axios.put(`${API}/guide/reset`);

// Plan Management
export const getPublicPlans = () => axios.get(`${API}/plans/public`);
export const getAdminPlans = () => axios.get(`${API}/plans/admin`);
export const createPlan = (data) => axios.post(`${API}/plans/admin`, data);
export const updatePlan = (id, data) => axios.put(`${API}/plans/admin/${id}`, data);
export const deletePlan = (id) => axios.delete(`${API}/plans/admin/${id}`);
export const getAvailableFeatures = () => axios.get(`${API}/plans/features`);

// Error Logs
export const getErrorLogs = (params) => axios.get(`${API}/error-logs`, { params });
export const getErrorStats = () => axios.get(`${API}/error-logs/stats`);
export const deleteErrorLog = (id) => axios.delete(`${API}/error-logs/${id}`);
export const clearErrorLogs = (params) => axios.delete(`${API}/error-logs`, { params });

// Visitor Analytics
export const getAnalyticsSummary = (days, userFilter) => axios.get(`${API}/visitor-analytics/summary`, { params: { days, user_filter: userFilter } });
export const getRecentVisits = (limit) => axios.get(`${API}/visitor-analytics/recent`, { params: { limit } });
export const clearAnalytics = (params) => axios.delete(`${API}/visitor-analytics`, { params });

// Independent Location Portal
export const getMyPortalLocations = () => axios.get(`${API}/portal-self/locations`);
export const createPortalLocation = (data) => axios.post(`${API}/portal-self/locations`, data);
export const updatePortalLocation = (id, data) => axios.put(`${API}/portal-self/locations/${id}`, data);
export const deletePortalLocation = (id) => axios.delete(`${API}/portal-self/locations/${id}`);

// Location Partners
export const getLocationPartners = (locationId) => axios.get(`${API}/portal-self/locations/${locationId}/partners`);
export const createLocationPartner = (locationId, data) => axios.post(`${API}/portal-self/locations/${locationId}/partners`, data);
export const updateLocationPartner = (locationId, partnerId, data) => axios.put(`${API}/portal-self/locations/${locationId}/partners/${partnerId}`, data);
export const deleteLocationPartner = (locationId, partnerId) => axios.delete(`${API}/portal-self/locations/${locationId}/partners/${partnerId}`);

// Expense Types & Expenses
export const getExpenseTypes = () => axios.get(`${API}/location-portal/expense-types`);
export const createExpenseType = (data) => axios.post(`${API}/location-portal/expense-types`, data);
export const getExpenses = (params) => axios.get(`${API}/location-portal/expenses`, { params });
export const createExpense = (data) => axios.post(`${API}/location-portal/expenses`, data);
export const deleteExpense = (id) => axios.delete(`${API}/location-portal/expenses/${id}`);
export const getPartnerDashboard = () => axios.get(`${API}/location-portal/partner-dashboard`);

export const getPortalLocationMachines = (locationId) => axios.get(`${API}/portal-self/locations/${locationId}/machines`);
export const addPortalMachine = (locationId, data) => axios.post(`${API}/portal-self/locations/${locationId}/machines`, data);
export const addPortalMachinesBulk = (locationId, data) => axios.post(`${API}/portal-self/locations/${locationId}/machines/bulk`, data);
export const updatePortalMachine = (locationId, machineId, data) => axios.put(`${API}/portal-self/locations/${locationId}/machines/${machineId}`, data);
export const removePortalMachine = (locationId, machineId) => axios.delete(`${API}/portal-self/locations/${locationId}/machines/${machineId}`);
export const bulkDeletePortalMachines = (locationId, machineIds) => axios.post(`${API}/portal-self/locations/${locationId}/machines/bulk-delete`, { machine_ids: machineIds });

// Vendors
export const getPortalVendors = (locationId) => axios.get(`${API}/portal-self/vendors`, { params: { location_id: locationId } });
export const createPortalVendor = (data) => axios.post(`${API}/portal-self/vendors`, data);
export const updatePortalVendor = (id, data) => axios.put(`${API}/portal-self/vendors/${id}`, data);
export const deletePortalVendor = (id) => axios.delete(`${API}/portal-self/vendors/${id}`);
export const getPortalCollections = (params) => axios.get(`${API}/portal-self/collections`, { params });
export const createPortalCollection = (data) => axios.post(`${API}/portal-self/collections`, data);

// Bulk Location Operations
export const bulkAssignManager = (data) => axios.put(`${API}/locations/bulk/assign-manager`, data);
export const bulkAssignReferrer = (data) => axios.put(`${API}/locations/bulk/assign-referrer`, data);
export const bulkTransferCompany = (data) => axios.put(`${API}/locations/bulk/transfer-company`, data);

// Geo Analytics
export const updateVisitorGeo = (data) => axios.post(`${API}/visitor-analytics/geo-update`, data);
export const getGeoHeatmap = (days) => axios.get(`${API}/visitor-analytics/geo-heatmap`, { params: { days } });

// Customers
export const getCustomers = (params) => axios.get(`${API}/customers`, { params });
export const createCustomer = (data) => axios.post(`${API}/customers`, data);
export const updateCustomer = (id, data) => axios.put(`${API}/customers/${id}`, data);
export const deleteCustomer = (id) => axios.delete(`${API}/customers/${id}`);

// Support Tickets
export const getTickets = (params) => axios.get(`${API}/support-tickets`, { params });
export const getTicketStats = () => axios.get(`${API}/support-tickets/stats`);
export const createTicket = (formData) => axios.post(`${API}/support-tickets`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateTicketStatus = (id, data) => axios.put(`${API}/support-tickets/${id}/status`, data);
export const deleteTicket = (id) => axios.delete(`${API}/support-tickets/${id}`);

// Activity Logs (for Production Monitor)
export const getActivityLogs = (params) => axios.get(`${API}/support-tickets/activity-logs`, { params });


// Tax & Extended Reports
export const getTaxReport = (params) => axios.get(`${API}/reports/tax-report`, { params });
export const getReferrerPayouts = (params) => axios.get(`${API}/reports/referrer-payouts`, { params });
export const getTruePnl = (params) => axios.get(`${API}/reports/true-pnl`, { params });

// Audit Trail
export const getAuditLogs = (params) => axios.get(`${API}/audit`, { params });
export const getEntityHistory = (entityType, entityId) => axios.get(`${API}/audit/entity/${entityType}/${entityId}`);


// Digital Signatures & Receipts
export const signCollection = (collectionId, signature) => axios.post(`${API}/collections/${collectionId}/sign`, { signature });
export const getCollectionReceipt = (collectionId) => axios.get(`${API}/collections/${collectionId}/receipt`);
export const getUnsignedCollections = (locationId) => axios.get(`${API}/collections/unsigned/${locationId}`);


// Notifications
export const registerPushToken = (token, platform) => axios.post(`${API}/notifications/register-push-token`, { token, platform });


// Bulk Delete
export const bulkDeletePreview = (entity, params) => axios.get(`${API}/${entity}/bulk-delete/preview`, { params });
export const bulkDelete = (entity, params) => axios.delete(`${API}/${entity}/bulk-delete`, { params });

// Bulk Resolve Pending
export const bulkResolvePending = (data, params) => axios.put(`${API}/collections/bulk-resolve-pending`, data, { params });

// Bulk Geocode Locations
export const bulkGeocodeLocations = (companyId, force = false) => {
  const body = { force };
  if (companyId) body.company_id = companyId;
  return axios.post(`${API}/locations/bulk-geocode`, body);
};
export const getGeocodeJobStatus = (jobId) => axios.get(`${API}/locations/bulk-geocode/status/${jobId}`);


// Accounting Periods
export const getAccountingPeriods = (params) => axios.get(`${API}/accounting-periods`, { params });
export const getAccountingPeriod = (id) => axios.get(`${API}/accounting-periods/${id}`);
export const suggestNextPeriod = (companyId) => axios.get(`${API}/accounting-periods/suggest-next`, { params: { company_id: companyId } });
export const createAccountingPeriod = (data) => axios.post(`${API}/accounting-periods`, data);
export const updateAccountingPeriod = (id, data) => axios.put(`${API}/accounting-periods/${id}`, data);
export const closeAccountingPeriod = (id) => axios.put(`${API}/accounting-periods/${id}/close`);
export const getSettlementPreview = (id) => axios.get(`${API}/accounting-periods/${id}/settlement-preview`);
export const reopenAccountingPeriod = (id) => axios.put(`${API}/accounting-periods/${id}/reopen`);
export const deleteAccountingPeriod = (id) => axios.delete(`${API}/accounting-periods/${id}`);
export const getPartnerCompanyPeriods = (companyId) => axios.get(`${API}/accounting-periods/partner-company-periods`, { params: { company_id: companyId } });

// Game Vendors (Software Providers)
export const getGameVendors = (search) => axios.get(`${API}/game-vendors`, { params: { search: search || undefined, per_page: 200 } });
export const createGameVendor = (data) => axios.post(`${API}/game-vendors`, data);
export const updateGameVendor = (id, data) => axios.put(`${API}/game-vendors/${id}`, data);
export const deleteGameVendor = (id) => axios.delete(`${API}/game-vendors/${id}`);

// Vended Games (External software at locations)
export const getVendedGames = (locationId) => axios.get(`${API}/vended-games`, { params: { location_id: locationId, per_page: 200 } });
export const createVendedGame = (data) => axios.post(`${API}/vended-games`, data);
export const updateVendedGame = (id, data) => axios.put(`${API}/vended-games/${id}`, data);
export const deleteVendedGame = (id) => axios.delete(`${API}/vended-games/${id}`);

// Cash Handoffs
export const getCashHandoffs = (params) => axios.get(`${API}/cash-handoffs`, { params });
export const createCashHandoff = (data) => axios.post(`${API}/cash-handoffs`, data);
export const confirmCashHandoff = (id, data) => axios.put(`${API}/cash-handoffs/${id}/confirm`, data);
export const deleteCashHandoff = (id) => axios.delete(`${API}/cash-handoffs/${id}`);
export const getCashHandoffBalances = () => axios.get(`${API}/cash-handoffs/balances`);
export const getCashHandoffSummary = () => axios.get(`${API}/cash-handoffs/summary`);
export const getUnhandedCollections = (managerId) => axios.get(`${API}/cash-handoffs/unhanded-collections`, { params: { manager_id: managerId } });
export const getHandoffRecipients = () => axios.get(`${API}/cash-handoffs/recipients`);
export const getHandoffPeriods = (params) => axios.get(`${API}/cash-handoffs/periods`, { params });
export const getLastHandoffPeriod = () => axios.get(`${API}/cash-handoffs/periods/last`);
export const previewHandoffPeriodClose = (startDate, endDate) => axios.get(`${API}/cash-handoffs/periods/preview`, { params: { start_date: startDate, end_date: endDate } });
export const closeHandoffPeriod = (data) => axios.post(`${API}/cash-handoffs/periods/close`, data);
export const downloadHandoffPeriodPdf = (periodId) => axios.get(`${API}/cash-handoffs/periods/${periodId}/pdf`, { responseType: 'blob' });
